import { Icons } from "@components/internal/Icons";
import styles from "./CollapseHeaderButton.module.scss";

interface CollapseHeaderButtonProps {
  isActive: boolean;
  onClick: () => void;
}

const CollapseHeaderButton: React.FC<CollapseHeaderButtonProps> = ({
  isActive,
  onClick,
}) => {
  const buttonClass = isActive
    ? `${styles.button} ${styles.active}`
    : styles.button;

  return (
    <button type="button" className={buttonClass} onClick={onClick}>
      <Icons name="projector" width={24} height={24} />
    </button>
  );
};

export default CollapseHeaderButton;
